export const AUTHS_URL = '/app/connections';
export const CREDIT_CARD_URL = '/app/settings/billing?section=card';
export const HELD_FOLDER_URL = '/app/zaps/folder/held';
const HELD_REASONS_QUERY_PARAM = 'held|throttled';
export const HELD_STATUSES_URL = `/app/history?status=${HELD_REASONS_QUERY_PARAM}&selected=all`;

export const REPLAY_STEP = 'replayStep';
